import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { getLatestManga, getTopRatedManga, categories } from '@/mocks/manga';

const heroBg = 'https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20illustration%20of%20a%20manga%20reader%20immersed%20in%20reading%20with%20floating%20manga%20panels%20and%20speech%20bubbles%20surrounding%20them%2C%20warm%20orange%20and%20golden%20gradient%20atmosphere%2C%20abstract%20Japanese%20wave%20patterns%2C%20soft%20dreamy%20lighting%2C%20minimalist%20modern%20composition%2C%20artistic%20and%20emotional%20design%20with%20rich%20textures&width=1600&height=900&seq=manga-hero-bg-01&orientation=landscape';

export default function Home() {
  const latest = getLatestManga(8);
  const topRated = getTopRatedManga(10);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '土豪漫画网',
    url: 'https://tuhaomanhua.com',
    description: '土豪漫画网按韩漫推荐、日漫大全、国漫排行榜精准分类，好看的漫画一应俱全，实时更新满足各类漫画爱好者。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://tuhaomanhua.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '土豪漫画网 - 首页',
    url: 'https://tuhaomanhua.com',
    description: '韩漫推荐、日漫大全、国漫排行榜精准分类，好看的漫画一应俱全。',
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '土豪漫画网有哪些漫画分类？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '土豪漫画网提供三大精准分类：韩漫推荐、日漫大全、国漫排行榜，涵盖恋爱、热血、奇幻、校园、武侠等众多题材，实时更新满足各类漫画爱好者的阅读需求。',
        },
      },
      {
        '@type': 'Question',
        name: '韩漫推荐都有哪些热门作品？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '韩漫推荐频道收录了女神降临、看脸时代、我独自升级、全知读者视角、金秘书为何那样等热门韩漫，每日更新最新的韩国漫画资讯与推荐。',
        },
      },
      {
        '@type': 'Question',
        name: '日漫大全包含哪些经典作品？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '日漫大全频道涵盖海贼王、咒术回战、鬼灭之刃、间谍过家家、葬送的芙莉莲、电锯人等经典与热门日本漫画，是日漫爱好者的必逛频道。',
        },
      },
      {
        '@type': 'Question',
        name: '国漫排行榜如何排序？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '国漫排行榜根据作品的人气、评分、更新频率等综合维度进行排序，收录了一人之下、狐妖小红娘、斗罗大陆、全职高手、镖人等优秀国漫作品。',
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webpageSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <ScrollToTop />

        <main>
          {/* Hero Section */}
          <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
            <div className="absolute inset-0">
              <img
                src={heroBg}
                alt="土豪漫画网 - 韩漫推荐日漫大全国漫排行榜"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

            <div className="relative z-10 w-full px-4 md:px-6 text-center">
              <h1 className="font-heading font-black text-3xl md:text-5xl lg:text-6xl text-background-50 mb-4 md:mb-6 tracking-tight">
                <span className="block">韩漫推荐 · 日漫大全</span>
                <span className="block mt-2 text-accent-400">国漫排行榜</span>
              </h1>
              <p className="text-background-50/80 text-sm md:text-lg max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
                按韩漫推荐、日漫大全、国漫排行榜精准分类，好看的漫画一应俱全，实时更新满足各类漫画爱好者
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <Link
                  to="/category/韩漫推荐"
                  className="w-48 md:w-52 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-200 text-center whitespace-nowrap"
                >
                  探索漫画世界
                </Link>
                <Link
                  to="/about"
                  className="w-48 md:w-52 py-3 border border-background-50/40 text-background-50 rounded-full font-medium text-sm hover:bg-background-50/10 transition-all duration-200 text-center whitespace-nowrap"
                >
                  了解更多
                </Link>
              </div>
            </div>

            <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
              <div className="w-6 h-10 border-2 border-background-50/40 rounded-full flex justify-center">
                <div className="w-1 h-2.5 bg-background-50/60 rounded-full mt-2 animate-bounce"></div>
              </div>
            </div>
          </section>

          {/* Category Entry Section */}
          <section className="w-full px-4 md:px-6 py-16 md:py-20">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-10 md:mb-14">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                  漫画分类大全
                </h2>
                <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
                  三大分类精准导航，快速找到你想看的漫画类型
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
                {[
                  {
                    key: '韩漫推荐',
                    icon: 'ri-kakao-talk-fill',
                    desc: '韩国漫画精选推荐，恋爱、奇幻、热血一网打尽',
                    bg: 'https://readdy.ai/api/search-image?query=A%20stylized%20Korean%20manhwa%20themed%20illustration%20with%20soft%20pastel%20pink%20and%20peach%20gradient%2C%20delicate%20Korean%20aesthetic%20pattern%2C%20minimalist%20composition%2C%20warm%20and%20romantic%20atmosphere%2C%20abstract%20design&width=600&height=400&seq=manga-cat-kr&orientation=landscape',
                    color: 'from-pink-500/20 to-rose-500/20',
                  },
                  {
                    key: '日漫大全',
                    icon: 'ri-sun-fill',
                    desc: '日本漫画全集收录，从经典到新番，日漫迷的天堂',
                    bg: 'https://readdy.ai/api/search-image?query=A%20stylized%20Japanese%20manga%20themed%20illustration%20with%20warm%20golden%20and%20amber%20gradient%2C%20Japanese%20wave%20and%20sun%20motif%2C%20minimalist%20composition%2C%20bright%20and%20energetic%20atmosphere%2C%20abstract%20design&width=600&height=400&seq=manga-cat-jp&orientation=landscape',
                    color: 'from-amber-500/20 to-orange-500/20',
                  },
                  {
                    key: '国漫排行榜',
                    icon: 'ri-flag-2-fill',
                    desc: '国产漫画排行榜，热门国漫一榜打尽，支持国漫崛起',
                    bg: 'https://readdy.ai/api/search-image?query=A%20stylized%20Chinese%20manhua%20themed%20illustration%20with%20rich%20red%20and%20golden%20gradient%2C%20Chinese%20cloud%20and%20dragon%20motif%2C%20minimalist%20composition%2C%20bold%20and%20grand%20atmosphere%2C%20abstract%20design&width=600&height=400&seq=manga-cat-cn&orientation=landscape',
                    color: 'from-red-500/20 to-rose-600/20',
                  },
                ].map((cat) => (
                  <Link
                    key={cat.key}
                    to={`/category/${cat.key}`}
                    className="group relative rounded-2xl overflow-hidden h-56 md:h-64 cursor-pointer"
                  >
                    <div className="absolute inset-0">
                      <img
                        src={cat.bg}
                        alt={cat.key}
                        className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      />
                    </div>
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                    <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-6">
                      <span className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-background-50/20 backdrop-blur-sm rounded-2xl mb-4">
                        <i className={`${cat.icon} text-2xl md:text-3xl text-background-50`}></i>
                      </span>
                      <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50 mb-2">
                        {cat.key}
                      </h3>
                      <p className="text-background-50/70 text-xs md:text-sm max-w-xs">
                        {cat.desc}
                      </p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          {/* Ranking Section */}
          <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-10 md:mb-14">
                <div>
                  <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
                    漫画排行榜
                  </h2>
                  <p className="text-foreground-600 text-sm">综合评分最高的漫画作品</p>
                </div>
                <Link
                  to="/category/国漫排行榜"
                  className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap"
                >
                  查看全部 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
                {topRated.slice(0, 5).map((manga, index) => (
                  <Link
                    key={manga.id}
                    to={`/manga/${manga.id}`}
                    className="group flex lg:flex-col items-center lg:items-stretch gap-4 lg:gap-0 bg-background-50 rounded-xl p-4 lg:p-0 lg:overflow-hidden hover:bg-background-200/30 transition-all duration-200"
                  >
                    <div className="relative flex-shrink-0">
                      <span className="absolute -top-1 -left-1 w-7 h-7 flex items-center justify-center bg-accent-500 text-background-50 rounded-full text-xs font-bold z-10">
                        {index + 1}
                      </span>
                      <div className="w-20 h-28 lg:w-full lg:h-60 rounded-lg lg:rounded-none lg:rounded-t-xl overflow-hidden">
                        <img
                          src={manga.coverImage}
                          alt={manga.title}
                          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                        />
                      </div>
                    </div>
                    <div className="flex-1 lg:p-4 min-w-0">
                      <h3 className="font-heading font-semibold text-foreground-900 text-sm lg:text-base truncate group-hover:text-primary-500 transition-colors">
                        {manga.title}
                      </h3>
                      <p className="text-xs text-foreground-500 mt-1">{manga.author}</p>
                      <div className="flex items-center gap-2 mt-2 lg:mt-3">
                        <span className="text-xs px-2 py-0.5 bg-accent-100 text-accent-700 rounded-full font-medium">
                          {manga.category}
                        </span>
                        <span className="text-xs text-foreground-500">
                          <i className="ri-star-fill text-accent-500 text-xs mr-0.5"></i>
                          {manga.rating}
                        </span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>

              <div className="mt-8 bg-background-50 rounded-xl p-5 md:p-6">
                <div className="space-y-3">
                  {topRated.slice(5).map((manga, index) => (
                    <Link
                      key={manga.id}
                      to={`/manga/${manga.id}`}
                      className="flex items-center gap-4 py-2.5 border-b border-background-200/60 last:border-0 hover:bg-background-100/50 rounded-lg px-3 -mx-3 transition-colors"
                    >
                      <span className="w-8 h-8 flex items-center justify-center bg-background-100 text-foreground-700 rounded-full text-sm font-semibold flex-shrink-0">
                        {index + 6}
                      </span>
                      <div className="flex-1 min-w-0">
                        <span className="font-medium text-foreground-900 text-sm">{manga.title}</span>
                        <span className="text-xs text-foreground-500 ml-2">{manga.author}</span>
                      </div>
                      <span className="text-xs px-2.5 py-1 bg-accent-100 text-accent-700 rounded-full font-medium whitespace-nowrap">
                        {manga.category}
                      </span>
                      <span className="text-sm text-accent-500 font-semibold whitespace-nowrap">
                        {manga.rating}分
                      </span>
                    </Link>
                  ))}
                </div>
              </div>

              <div className="mt-6 text-center sm:hidden">
                <Link
                  to="/category/国漫排行榜"
                  className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium"
                >
                  查看全部排行榜 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </section>

          {/* Latest Updates Section */}
          <section className="w-full px-4 md:px-6 py-16 md:py-20">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-10 md:mb-14">
                <div>
                  <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
                    最新更新
                  </h2>
                  <p className="text-foreground-600 text-sm">实时追踪最新漫画章节更新</p>
                </div>
                <div className="flex items-center gap-2">
                  {categories.map((cat) => (
                    <Link
                      key={cat}
                      to={`/category/${cat}`}
                      className="text-xs md:text-sm px-3 py-1.5 rounded-full border border-background-300 text-foreground-600 hover:text-primary-500 hover:border-primary-300 transition-all duration-200 whitespace-nowrap"
                    >
                      {cat}
                    </Link>
                  ))}
                </div>
              </div>

              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
                {latest.map((manga) => (
                  <Link
                    key={manga.id}
                    to={`/manga/${manga.id}`}
                    className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300"
                  >
                    <div className="aspect-[3/4] overflow-hidden">
                      <img
                        src={manga.coverImage}
                        alt={manga.title}
                        className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      />
                    </div>
                    <div className="p-3 md:p-4">
                      <h3 className="font-heading font-semibold text-foreground-900 text-sm truncate group-hover:text-primary-500 transition-colors">
                        {manga.title}
                      </h3>
                      <div className="flex items-center justify-between mt-2">
                        <span className="text-xs text-foreground-500">
                          {manga.chapters}话
                        </span>
                        <span className={`text-xs font-medium ${manga.status === '连载中' ? 'text-green-600' : 'text-foreground-500'}`}>
                          {manga.status}
                        </span>
                      </div>
                      <div className="flex items-center gap-1 mt-2 text-xs text-foreground-500">
                        <i className="ri-time-line"></i>
                        <span>{manga.updatedAt}</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>

              <div className="text-center mt-10">
                <Link
                  to="/category/韩漫推荐"
                  className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
                >
                  浏览全部漫画 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </section>

          {/* Features Section */}
          <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                  为什么选择土豪漫画网
                </h2>
                <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
                  为漫画爱好者打造的专属漫画分类平台
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {[
                  { icon: 'ri-compass-3-line', title: '精准分类', desc: '韩漫推荐、日漫大全、国漫排行榜三大分类，快速定位你想要的漫画类型' },
                  { icon: 'ri-timer-flash-line', title: '实时更新', desc: '每日追踪最新漫画更新动态，第一时间掌握连载进度' },
                  { icon: 'ri-star-line', title: '客观评分', desc: '基于综合维度排行的漫画评分系统，帮你发现优质漫画' },
                  { icon: 'ri-heart-line', title: '漫画社区', desc: '与千万漫画爱好者一起交流讨论，分享你的漫画心得' },
                ].map((feat) => (
                  <div key={feat.title} className="bg-background-50 rounded-xl p-6 text-center hover:bg-background-200/20 transition-colors duration-200">
                    <span className="w-12 h-12 flex items-center justify-center bg-primary-100 text-primary-500 rounded-xl mx-auto mb-4">
                      <i className={`${feat.icon} text-xl`}></i>
                    </span>
                    <h3 className="font-heading font-semibold text-foreground-900 mb-2">{feat.title}</h3>
                    <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="relative w-full py-20 md:py-24 overflow-hidden">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20gradient%20abstract%20background%20with%20soft%20orange%20and%20golden%20tones%2C%20manga%20reading%20atmosphere%2C%20cozy%20and%20inviting%2C%20minimalist%20design%2C%20subtle%20paper%20texture%2C%20artistic%20and%20warm%20ambiance&width=1600&height=600&seq=manga-cta-bg&orientation=landscape"
                alt=""
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute inset-0 bg-black/40"></div>
            <div className="relative z-10 max-w-3xl mx-auto text-center px-4">
              <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-background-50 mb-4">
                开始你的漫画之旅
              </h2>
              <p className="text-background-50/80 text-sm md:text-base mb-8 max-w-xl mx-auto">
                海量韩漫、日漫、国漫等你来探索，总有一部漫画让你心动
              </p>
              <Link
                to="/category/日漫大全"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-accent-500 text-background-50 rounded-full font-medium text-sm hover:bg-accent-600 transition-all duration-200 whitespace-nowrap"
              >
                立即浏览 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}